<div *ngIf="data?.asOfDate;else noData">
  <div style="display: flex;">
    <p class="disclaimer rps-grey rps-paragraph-two" data-rpa-tag-id="annuallyDate">as of {{ data?.asOfDate | ESTPipe |
      DashIfEmpty }}</p>
  </div>
  <div style="position: relative;">
    <div class="table-container">
      <table scrollingTable aria-label="Performance annually">
        <thead>
          <tr>
            <th scope="col">Year</th>
            <th scope="col" *ngIf="!profileData?.is529 && !profileData?.isExternal">
              <p>Capital return by NAV</p>
            </th>
            <th scope="col" *ngIf="profileData?.is529">
              <p>Total return</p>
            </th>
            <th scope="col" *ngIf="!profileData?.is529 && !profileData?.isExternal">
              <p>Income return by NAV</p>
            </th>
            <th scope="col" *ngIf="!profileData?.is529">
              <p>Total return by NAV</p>
            </th>
            <th scope="col" *ngIf="profileData?.isETF && !profileData?.isExternal">
              <p>Total return by Market Price</p>
            </th>
            <th *ngIf="!profileData?.isExternal" scope="col">
              <p class="tool-tip-cell">
                <label>Benchmark<sup *ngIf="benchmarkFootNote?.text">{{benchmarkFootNote?.id}}</sup></label>
                <c11n-tooltip  [autoOrientation]="false" colorMode="on-light" class="inner-align" direction="left" labelText="Benchmark">
                  <span c11nTooltipContent>{{ data?.benchmarkShortName || '(Benchmark)' }}</span>
                </c11n-tooltip>
              </p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let return of tableData">
            <th scope="col" data-rpa-tag-id="yearAnnually">{{return?.year | DashIfEmpty }}</th>
            <td *ngIf="!profileData?.isExternal" scope="col" data-rpa-tag-id="capitalRtnPct">{{return?.capitalRtn |
              VMFPercent | DashIfEmpty }}</td>
            <td scope="col" *ngIf="!profileData?.is529 && !profileData?.isExternal" data-rpa-tag-id="incomeRtnPct">
              {{return?.incomeRtn | VMFPercent | DashIfEmpty }}</td>
            <td scope="col" *ngIf="!profileData?.is529" data-rpa-tag-id="totalRtnPct">{{return?.totalRtn | VMFPercent |
              DashIfEmpty }}</td>
            <td scope="col" *ngIf="profileData?.isETF && !profileData?.isExternal" data-rpa-tag-id="totalRtnMarketPricePct">
              {{return?.marketPriceTotalRtn | VMFPercent | DashIfEmpty }}</td>
            <td *ngIf="!profileData?.isExternal" scope="col" data-rpa-tag-id="benchmarkPct">{{return?.benchmarkTotalRtn
              | VMFPercent | DashIfEmpty }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<ng-template #noData>
  <p class="rps-paragraph-two" *ngIf="!data?.asOfDate" class='no-data'>This information is temporarily unavailable.</p>
</ng-template>
